/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Incomplete_CommentInputs */

const en_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incomplete Comment`)
};

const fr_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commentaire incomplet`)
};

const de_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unvollständiger Kommentar`)
};

const it_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commento incompleto`)
};

const ru_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неполный комментарий`)
};

const es_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentario incompleto`)
};

const zh_cn2_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评论不完整`)
};

const ja_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不完全なコメント`)
};

const hi_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधूरा कमेंट`)
};

const pt_pt2_editor_filter_incomplete_comment = /** @type {(inputs: Editor_Filter_Incomplete_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentário incompleto`)
};

/**
* | output |
* | --- |
* | "Incomplete Comment" |
*
* @param {Editor_Filter_Incomplete_CommentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_incomplete_comment = /** @type {((inputs?: Editor_Filter_Incomplete_CommentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Incomplete_CommentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_incomplete_comment(inputs)
	if (locale === "de") return de_editor_filter_incomplete_comment(inputs)
	if (locale === "it") return it_editor_filter_incomplete_comment(inputs)
	if (locale === "ru") return ru_editor_filter_incomplete_comment(inputs)
	if (locale === "es") return es_editor_filter_incomplete_comment(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_incomplete_comment(inputs)
	if (locale === "ja") return ja_editor_filter_incomplete_comment(inputs)
	if (locale === "hi") return hi_editor_filter_incomplete_comment(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_incomplete_comment(inputs)
	return en_editor_filter_incomplete_comment(inputs)
});